var map = {
	"./air-nga-en/assets/main-fantasy-header.png": 38656,
	"./ais-tai-en/assets/main-fantasy-header.png": 50677,
	"./ais-tai-tha/assets/main-fantasy-header.png": 87009,
	"./demo-arabic/assets/main-fantasy-header.png": 76521,
	"./demo-et-en/assets/main-fantasy-header.png": 24932,
	"./demo-romanian/assets/main-fantasy-header.png": 64062,
	"./demo-um-en/assets/main-fantasy-header.png": 1033,
	"./dtac-tai-en/assets/main-fantasy-header.png": 21118,
	"./dtac-tai-tha/assets/main-fantasy-header.png": 67880,
	"./ethiotel-et-amh/assets/main-fantasy-header.png": 35578,
	"./ethiotel-et-en/assets/main-fantasy-header.png": 48323,
	"./mtn-cg-fr/assets/main-fantasy-header.png": 57330,
	"./mtn-ci-fr/assets/main-fantasy-header.png": 62776,
	"./mtn-cmr-fr/assets/main-fantasy-header.png": 98940,
	"./mtn-gha-en/assets/main-fantasy-header.png": 37467,
	"./mtn-nga-en/assets/main-fantasy-header.png": 49999,
	"./mtn-zam-en/assets/main-fantasy-header.png": 71945,
	"./saf-ke-en/assets/main-fantasy-header.png": 3724,
	"./saudi-uae-en/assets/main-fantasy-header.png": 94713,
	"./tlk-za-en/assets/main-fantasy-header.png": 48480,
	"./vc-za-en/assets/main-fantasy-header.png": 89148
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74202;